/**
 * Part of rayband project.
 *
 * @copyright  Copyright (C) 2023 __ORGANIZATION__.
 * @license    __LICENSE__
 */

import { reactive } from 'vue';

const combinationStorage = reactive({
  flowIndex: 0,
  modalState: false,
  modalType: 'initial',
  modalCurrentComponent: 'buttons',
  categoryType: 'connector',
  categoryPath: null,
  productId: null,
  initialItem: null,
  terminalItem: null,
  mappingIds: null,
  cables: {},
  currentEditCable: null,
  quantity: 1,
  total: 0,
  beforeUnloadEnabled :true,
  getMappingConnector: false,
  showBreadcrumb: true,
  onlyCables: true,
});

combinationStorage.backToComponent = (component) => {
  combinationStorage.modalCurrentComponent = component;
};

combinationStorage.goToCategoryList = (path) => {
  combinationStorage.categoryPath = path;
  combinationStorage.modalCurrentComponent = 'categoryList';
};

combinationStorage.goToProductList = (categoryPath) => {
  combinationStorage.categoryPath = categoryPath;
  combinationStorage.modalCurrentComponent = 'productList';
};

combinationStorage.goToProductItem = (id) => {
  combinationStorage.productId = id;
  combinationStorage.modalCurrentComponent = 'productItem';
};

export default combinationStorage;
